<template>
  <v-text-field
    v-model="modelValue"
    v-bind="$attrs"
    v-on="$listeners"
    class="rounded-0 thin-border"
    :class="{
      'common-input--filter' : (filterStyle && modelValue)
    }"
    color="black"
    outlined
    solo
    flat
    dense
    :hide-details="hideDetails"
    :validate-on-blur="validateOnBlur"
    tile
    ref="input"
    :height="height"
    :clearable="clearable"
  >
    <template v-for="(_, slot) in $slots">
      <template :slot="slot">
        <slot :name="slot" />
      </template>
    </template>
    <template v-for="(_, slot) in $scopedSlots" v-slot:[slot]="props">
      <slot :name="slot" v-bind="props" />
    </template>
  </v-text-field>
</template>

<script>
export default {
  name: 'CommonInput',
  props: {
    value: {
      type: [String, Number],
      required: false,
      default: null
    },
    height: {
      type: [String, Number],
      required: false,
      default: 36
    },
    hideDetails: {
      type: Boolean,
      required: false,
      default: true
    },
    filterStyle: {
      type: Boolean,
      required: false,
      default: false
    },
    validateOnBlur: {
      type: Boolean,
      required: false,
      default: true
    },
    clearable: {
      type: Boolean,
      required: false,
      default: false
    },
  },
  computed: {
    modelValue: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
      }
    }
  },
  methods: {
    validate (val = true) {
      return this.$refs.input.validate(val)
    },
  },
}
</script>

<style lang="scss">
input[type=number] {
  -moz-appearance: textfield !important;
  appearance: textfield !important;
  -webkit-appearance: none;
}

input[type=number]::-webkit-inner-spin-button,
input[type=number]::-webkit-outer-spin-button {
  -webkit-appearance: none !important;
  margin: 0;
}

.v-text-field {
  &__prefix {
    color: #919191;
  }

  &__details {
    padding: 0 !important;
  }
}

.v-messages__message {
  font-family: 'Lato', sans-serif;
  font-style: italic;
  font-weight: 400;
  font-size: 14px;
  color: #FF5A60;
  letter-spacing: 0.186667px;
  text-align: left;
}

.common-input--filter {
  & .v-input__slot {
    background-color: rgb(237, 252, 251) !important;
  }
}

.theme--light.v-text-field--solo > .v-input__control > .v-input__slot {
  background: #fff;
}

.v-input {
  font-family: 'Lato-Regular', sans-serif;
  font-size: 14px;
  line-height: 18px;

  &--is-disabled:not(.common-input--filter) {
    & > .v-input__control > .v-input__slot {
      color: #4A4A4A;
      background: #F4F4F4 !important;
    }

    & input {
      color: #4A4A4A;
    }
  }

  &--is-focused {
    & > .v-input__control .v-input__slot {
      border-color: #A7DAD8;

      & > fieldset {
        border-color: #A7DAD8;
      }
    }
  }
}

.error--text {
  .v-input__slot {
    background-color: #FBE7E9 !important;
  }

  fieldset {
    border-color: #FA5E5E !important;
  }
}

.v-input__control {
  min-height: 30px !important;
  gap: 10px;

  .v-input__slot {
    min-height: 30px !important;
    margin: 0 !important;

    input {
      font-family: 'Lato-Regular', sans-serif;
      font-size: 14px;
      line-height: 18px;

      &::placeholder {
        font-family: 'Lato-Italic', sans-serif;
        font-size: 14px;
        line-height: 18px;
        color: #979797;
      }
    }

    fieldset {
      border-width: 1px !important;
      border-color: #D3D2D2;
    }
  }
}
</style>
